import { z } from 'zod';

export const RefreshTokenRequestSchema = z.object({
  token: z.string(),
  originUrl: z.string().optional(),
  isEmbedded: z.boolean().optional(),
  // FGO Insights T3 capture: deep-link origin/wlId, mirroring TokenRequestSchema --
  // see docs/planned/fgo-insights/tasks/03-reach-entry-source-capture.md
  origin: z.string().optional(),
  wlId: z.string().optional(),
});

export type RefreshTokenRequest = z.infer<typeof RefreshTokenRequestSchema>;


